import React from 'react';
import { Block, BlockBetween, BlockHead, BlockHeadContent } from '../../components/Component';

const LoadingPageLoader = ({ tenant_info }) => {
  return (
    <>
      <div style={{ height: "92vh", display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
        <Block size="lg">
          <BlockBetween className="center">
            <BlockHead>
              <BlockHeadContent>
                <div className="brand-logo text-center" style={{ marginBottom: 12 }}>
                  {
                    tenant_info?.tenant_logo ?
                      <>
                        <img className="logo-light logo-img logo-img-website" src={tenant_info?.tenant_logo} alt="logo" />
                        <img className="logo-custom-img-main_app_loading w-70" src={tenant_info?.tenant_logo} alt="logo-dark" />
                      </>
                      :
                      <>
                      </>
                  }
                </div>
                <div className="w-70 m-auto" >
                  <div className="text-soft fw-bold mt-6" style={{ fontSize: 24 }}>Loading Page...</div>
                  <div className="nk-loader "></div>
                </div>
              </BlockHeadContent>
            </BlockHead>
          </BlockBetween>
        </Block>
      </div>
    </>
  );
};

export default LoadingPageLoader;